"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function OurExpertise() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const plates = [{
    number: "§ 01",
    titleStart: "Credit ",
    titleItalic: "Architecture",
    titleEnd: "",
    description: "Beyond simple repair, we engineer a robust personal credit profile designed to withstand institutional scrutiny and unlock premium financial opportunities.",
    fee: "SELECTIVE",
    settlement: "ONGOING",
    tier: "ELITE"
  }, {
    number: "§ 02",
    titleStart: "Business ",
    titleItalic: "Credit",
    titleEnd: " Build",
    description: "Strategic development of corporate credit identities, enabling business owners to access capital without personal liability or SSN requirements.",
    fee: "PREMIUM",
    settlement: "PHASED",
    tier: "CORPORATE"
  }, {
    number: "§ 03",
    titleStart: "Personal ",
    titleItalic: "Funding",
    titleEnd: "",
    description: "High-limit liquidity solutions for qualified individuals, leveraging optimized credit profiles to secure the most competitive market rates.",
    fee: "PERFORMANCE",
    settlement: "T+3",
    tier: "PRIVATE"
  }, {
    number: "§ 04",
    titleStart: "Business ",
    titleItalic: "Capital",
    titleEnd: "",
    description: "Customized funding structures for established enterprises and startups, focusing on revenue-based and credit-based capital injections.",
    fee: "STRUCTURED",
    settlement: "T+5",
    tier: "ENTERPRISE"
  }, {
    number: "§ 05",
    titleStart: "Wealth ",
    titleItalic: "Strategy",
    titleEnd: "",
    description: "A bespoke roadmap for capital preservation and growth, integrating credit leverage with strategic asset acquisition for long-term prosperity.",
    fee: "ADVISORY",
    settlement: "QUARTERLY",
    tier: "STRATEGIC"
  }, {
    number: "§ 06",
    titleStart: "Elite ",
    titleItalic: "Mentoring",
    titleEnd: "",
    description: "Direct access to financial architects for high-level coaching on credit engineering, funding navigation, and sophisticated wealth management.",
    fee: "RETAINER",
    settlement: "MONTHLY",
    tier: "MENTORSHIP"
  }];
  return <section data-section-id="1648" id="our-expertise" className="bg-background text-foreground py-32 md:py-44 border-t border-primary/20">
      <div className="max-w-[1440px] mx-auto px-8 md:px-16">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-24 mb-24 md:mb-32 transition-all duration-[880ms] ease-[cubic-bezier(0.16,1,0.3,1)] ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="md:col-span-9">
            <div className="font-mono text-xs md:text-sm font-bold tracking-[0.2em] uppercase text-primary mb-8">
              § 01 — Our Expertise
            </div>
            <h2 className="font-default font-medium text-foreground leading-[1.1] tracking-[-0.01em] text-[clamp(2.5rem,5.2vw,5rem)]">
              The <span className="italic text-primary">Blueprint</span> of Financial Engineering.
            </h2>
            {}
            <div className="flex items-center mt-12">
              <div className={`h-px bg-primary transition-transform duration-[720ms] ease-[cubic-bezier(0.16,1,0.3,1)] origin-left ${headerVisible ? "scale-x-100" : "scale-x-0"}`} style={{
              width: "96px"
            }} />
              <div className={`w-1 h-1 bg-primary ml-1 transition-opacity duration-200 ${headerVisible ? "opacity-100" : "opacity-0"}`} style={{
              transitionDelay: headerVisible ? "720ms" : "0ms"
            }} />
            </div>
          </div>

          {}
          <div className="md:col-span-3 flex flex-col gap-3 font-mono text-xs tracking-[0.14em] uppercase text-muted-foreground md:pt-4">
            <div className="flex items-center gap-3">
              <span className="text-primary">SOLUTIONS</span>
              <span className="text-primary/30">———</span>
              <span className="text-foreground">06</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-primary">FIRM</span>
              <span className="text-primary/30">———</span>
              <span className="text-foreground">BENEWEALTH</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-primary">EST</span>
              <span className="text-primary/30">———</span>
              <span className="text-foreground">MMXXIV</span>
            </div>
          </div>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {plates.map((plate, i) => <div key={i} data-index={i} className={`group relative transition-all duration-[880ms] ease-[cubic-bezier(0.16,1,0.3,1)] ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: `${i * 90}ms`
        }}>
              <Card className="relative bg-secondary/10 text-card-foreground border border-muted group-hover:border-primary p-12 transition-colors duration-[320ms] ease-[cubic-bezier(0.16,1,0.3,1)] gap-0 py-0 overflow-hidden shadow-md rounded-md">
                {}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-[380ms] pointer-events-none" style={{
              background: "radial-gradient(circle at top right, hsla(43, 45%, 65%, 0.05), transparent 60%)"
            }} />

                {}
                <span className="absolute top-0 left-0 w-2 h-px bg-primary transition-all duration-[320ms] group-hover:w-3.5" />
                <span className="absolute top-0 left-0 w-px h-2 bg-primary transition-all duration-[320ms] group-hover:h-3.5" />
                {}
                <span className="absolute top-0 right-0 w-2 h-px bg-primary transition-all duration-[320ms] group-hover:w-3.5" />
                <span className="absolute top-0 right-0 w-px h-2 bg-primary transition-all duration-[320ms] group-hover:h-3.5" />
                {}
                <span className="absolute bottom-0 left-0 w-2 h-px bg-primary transition-all duration-[320ms] group-hover:w-3.5" />
                <span className="absolute bottom-0 left-0 w-px h-2 bg-primary transition-all duration-[320ms] group-hover:h-3.5" />
                {}
                <span className="absolute bottom-0 right-0 w-2 h-px bg-primary transition-all duration-[320ms] group-hover:w-3.5" />
                <span className="absolute bottom-0 right-0 w-px h-2 bg-primary transition-all duration-[320ms] group-hover:h-3.5" />

                {}
                <div className="relative font-mono text-xs font-bold tracking-[0.2em] uppercase text-primary mb-10">
                  {plate.number}
                </div>

                {}
                <h3 className="relative font-default font-semibold text-foreground leading-[1.4] tracking-[0.05em] text-[clamp(1.25rem,2vw,1.75rem)] uppercase mb-2">
                  {plate.titleStart}
                  <span className="italic font-serif normal-case tracking-normal text-primary">{plate.titleItalic}</span>
                  {plate.titleEnd}
                </h3>

                {}
                <div className="relative overflow-hidden mb-8">
                  <p className="font-default text-card-foreground/80 leading-[1.6] text-[clamp(1rem,1.05vw,1.125rem)] opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[380ms] ease-[cubic-bezier(0.16,1,0.3,1)] max-h-0 group-hover:max-h-48 mt-0 group-hover:mt-6">
                    {plate.description}
                  </p>
                </div>

                {}
                <div className="relative flex items-center mb-8">
                  <div className="h-px w-16 bg-primary/40" />
                  <div className="w-1 h-1 bg-primary ml-1" />
                </div>

                {}
                <div className="relative flex flex-col gap-2.5 font-mono text-xs tracking-[0.14em] uppercase">
                  <div className="flex items-center gap-3">
                    <span className="text-primary">FEE</span>
                    <span className="text-primary/30">———</span>
                    <span className="text-foreground">{plate.fee}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="text-primary">STRUCTURE</span>
                    <span className="text-primary/30">———</span>
                    <span className="text-foreground">{plate.settlement}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="text-primary">TIER</span>
                    <span className="text-primary/30">———</span>
                    <span className="text-foreground">{plate.tier}</span>
                  </div>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}